import { Patient } from "../../../api/types";

interface PatientInfoProps {
    patient: Patient;
    program: string
}

export const PatientInfo = ({ patient, program }: PatientInfoProps) => {
    return (
        <div className={`"flex flex-col gap-1 sm:gap-2 items-start w-full flex sm:flex-row sm:items-center`}>
            <div className="flex flex-wrap items-center mt-1">
                <div className="flex items-center whitespace-nowrap">
                {/* <span className="text-xs md:text-sm font-medium" style={{ color: "#2D2F35" }}>
                        {patient.email}
                    </span> */}
                    <span className="text-xs md:text-sm font-medium" style={{ color: "#2D2F35" }}>
                        {program === "urgent-care" ? "Urgent Care" : "Weight Loss"}
                    </span>
                    <span className="mx-2 text-sm" style={{ color: "#667085" }}>•</span>
                    <span className="text-xs md:text-sm font-medium" style={{ color: "#2D2F35" }}>
                        {patient.age} Years
                    </span>
                    <span className="mx-2 text-sm" style={{ color: "#667085" }}>•</span>
                    <span className="text-xs md:text-sm font-medium" style={{ color: "#2D2F35" }}>
                        {patient.gender}
                    </span>
                </div>
            </div>
        </div>
    );
};
